"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = HBTextTruncator;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _mixins = require("../../styles/mixins");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function HBTextTruncator(_ref) {
  var testIdName = _ref.testIdName,
    testId = _ref.testId,
    lines = _ref.lines,
    readMoreText = _ref.readMoreText,
    readLessText = _ref.readLessText,
    children = _ref.children;
  var _useState = (0, _react.useState)(lines > 0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isClamped = _useState2[0],
    setIsClamped = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isOverflowed = _useState4[0],
    setIsOverflowed = _useState4[1];
  var clamperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var container = clamperRef.current;
    if (!container || !isClamped) {
      return;
    }
    var checkOverflow = function checkOverflow() {
      var isOverflow = container.scrollHeight > container.clientHeight;
      setIsOverflowed(isOverflow);
    };
    checkOverflow();
    var resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(container);
    return function () {
      return resizeObserver.disconnect();
    };
  }, [children, lines, isClamped]);
  var toggleClamp = function toggleClamp() {
    return setIsClamped(function (prev) {
      return !prev;
    });
  };
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'text-truncator',
    componentName: 'HBTextTruncator'
  });
  return /*#__PURE__*/_react["default"].createElement(Container, {
    "data-testid": finalTestId ? "".concat(finalTestId, "-wrapper") : undefined
  }, /*#__PURE__*/_react["default"].createElement(Clamper, {
    clamp: isClamped,
    ref: clamperRef,
    lines: lines
  }, children), isOverflowed && /*#__PURE__*/_react["default"].createElement(ToggleButton, {
    onClick: toggleClamp,
    testId: finalTestId ? "".concat(finalTestId, "-toggle") : undefined
  }, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "body14"
  }, isClamped ? readMoreText : readLessText)));
}

// -------------------------------- Styles -------------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBTextTruncator__Container",
  componentId: "sc-182p525-0"
})([""]);
var Clamper = _styledComponents["default"].div.withConfig({
  displayName: "HBTextTruncator__Clamper",
  componentId: "sc-182p525-1"
})(["display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;-webkit-line-clamp:", ";white-space:pre-wrap;", ""], function (_ref2) {
  var clamp = _ref2.clamp,
    lines = _ref2.lines;
  return clamp ? lines : '';
}, (0, _mixins.printCss)("\n        -webkit-line-clamp: unset;\n    "));
var ToggleButton = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBTextTruncator__ToggleButton",
  componentId: "sc-182p525-2"
})(["text-decoration:underline;width:fit-content;", ""], _mixins.hideInPrint);
//# sourceMappingURL=HBTextTruncator.js.map